import React from 'react';
import styles from './Explanation.module.scss';

const Explanation = ({ Icon, title, text }) => (
  <div className={styles.explanation}>
    <Icon className={styles.icon} />
    <div className={styles.explainBlock}>
      <h5 className={styles.title}>{title}</h5>
      <p className={styles.text}>{text}</p>
    </div>
  </div>
);


export default Explanation;
